module.exports = __webpack_public_path__ + "static/media/reception.c27bd428.png";